import { Box } from '@mantine/core'
import { StatusMeter } from '../common/StatusMeter'
import { PanelTitle } from '../common/PanelTitle'

export function StatusPanel({ overallProgress }) {
  return (
    <Box
      style={{
        height: '100%',
        background: 'linear-gradient(to top, rgba(6, 14, 26, 0.96), rgba(10, 22, 40, 0.92))',
        borderTop: '1px solid rgba(0, 255, 255, 0.1)',
      }}
      px="lg"
      pt="md"
    >
      <PanelTitle mb={6}>PROGRESS</PanelTitle>
      <StatusMeter label="Overall" value={overallProgress} color="green" />
    </Box>
  )
}
